import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import apiUrl from "../../Environment/Api";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useForceUpdate = () => {
  const [, forceUpdate] = useState();
  return useCallback(() => forceUpdate((prev) => !prev), []);
};

function InvoiceUpdate() {
  const forceUpdate = useForceUpdate();
  const navigate = useNavigate();
  const [exchangeRate, setExchangeRate] = useState("");

  const { invoice_id } = useParams();

  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceData, setInvoiceDetails] = useState({});
  const [getclientaddress, setclientaddress] = useState("");
  const [getclientcountry, setclientcountry] = useState("");
  const [getclientmobile, setclientmobile] = useState("");
  const [getclientName, setclientName] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [invoicedetailsId, setinvoicedetailsId] = useState("");

  // ── Generate filter state ─────────────────────────────────────────────────
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [taskData, setTaskData] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);

  // Dynamic columns
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [columnNames, setColumnNames] = useState({
    standard: "Standard",
    premier: "Premier",
    twilight: "Twilight",
    day_to_dusk: "Day to Dusk",
    vra: "VRA",
    vr: "VR",
    col7: "Column 7",
    col8: "Column 8",
    col9: "Column 9",
    col10: "Column 10",
    col11: "Column 11",
    col12: "Column 12",
  });

  // clientrate fetch
  const [clientRate, setClientRate] = useState([]);
  const fetchClientRate = async () => {
    try {
      const response = await axios.get(`${apiUrl}/clientrate`);
      setClientRate(response.data || []);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchClientRate();
  }, []);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [pendingColumnKey, setPendingColumnKey] = useState(null);
  const [modalColumnName, setModalColumnName] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  const columnOrder = [
    "standard",
    "premier",
    "twilight",
    "day_to_dusk",
    "vra",
    "vr",
    "col7",
    "col8",
    "col9",
    "col10",
    "col11",
    "col12",
  ];

  const TASK_COLUMN_MAP = {
    standard: "standard",
    premier: "premier",
    twilight: "twilight",
    dtd: "day_to_dusk",
    vra: "vra",
    vr: "vr",
  };

  const TASK_COLUMN_LABELS = {
    standard: "Standard",
    premier: "Premier",
    twilight: "Twilight",
    dtd: "Day to Dusk",
    vra: "VRA",
    vr: "VR",
  };

  // ── Column helpers ────────────────────────────────────────────────────────
  const handleAddColumn = () => {
    const available = columnOrder.filter(
      (col) => !visibleColumns.includes(col),
    );
    if (available.length > 0) {
      setPendingColumnKey(available[0]);
      setModalColumnName(columnNames[available[0]]);
      setIsEditMode(false);
      setShowModal(true);
    }
  };

  const handleEditColumn = (columnKey) => {
    setPendingColumnKey(columnKey);
    setModalColumnName(columnNames[columnKey]);
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleRemoveColumn = (columnKey) => {
    setVisibleColumns((prev) => prev.filter((col) => col !== columnKey));
    setTableData((prev) => prev.map((row) => ({ ...row, [columnKey]: "" })));
  };

  const handleModalSave = () => {
    if (modalColumnName.trim() !== "" && pendingColumnKey) {
      setColumnNames((prev) => ({
        ...prev,
        [pendingColumnKey]: modalColumnName,
      }));
      if (!isEditMode) {
        setVisibleColumns((prev) => [...prev, pendingColumnKey]);
      }
      setShowModal(false);
      setModalColumnName("");
      setPendingColumnKey(null);
      setIsEditMode(false);
    } else {
      alert("Please enter a column name");
    }
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setModalColumnName("");
    setPendingColumnKey(null);
    setIsEditMode(false);
  };

  // ── Load existing invoice on mount ────────────────────────────────────────
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Invoice header
        const responseDetails = await axios.get(
          apiUrl + `/invoicedetails/${invoice_id}`,
        );
        const invoiceDetails = responseDetails.data[0];
        setInvoiceDetails(invoiceDetails);
        setSelectedClient(invoiceDetails.clientId);
        setinvoicedetailsId(invoiceDetails.id);
        setData({
          invoiceId: invoiceDetails.invoiceId,
          date: invoiceDetails.date,
          dueDate: invoiceDetails.dueDate,
          notes: invoiceDetails.notes,
          totalTax: invoiceDetails.totalTax,
          paymentStatus: invoiceDetails.paymentStatus,
          totalAmount: invoiceDetails.totalAmount,
          paymentDate: invoiceDetails.paymentDate,
        });
        setInvoiceNo(invoiceDetails.invoiceId);

        // 2. Invoice rows — NEW structure: client → editors
        const rowRes = await axios.get(apiUrl + `/invoicelist/${invoice_id}`);

        const flatRows = [];

        // Response is now: [{ client_id, client_name, client_address, editors: [...] }]
        // rowRes.data.forEach((clientGroup) => {
        //   clientGroup.editors.forEach((editor) => {
        //     const standardQty = parseFloat(editor?.standard) || 0;
        //     const premierQty = parseFloat(editor?.premier) || 0;
        //     const twilightQty = parseFloat(editor?.twilight) || 0;
        //     const dtdQty = parseFloat(editor?.day_to_dusk) || 0;
        //     const vraQty = parseFloat(editor?.vra) || 0;
        //     const vrQty = parseFloat(editor?.vr) || 0;

        //     const standardRate = parseFloat(editor?.standardrate) || 0;
        //     const premierRate = parseFloat(editor?.premierrate) || 0;
        //     const twilightRate = parseFloat(editor?.twilightrate) || 0;
        //     const dtdRate = parseFloat(editor?.dtdrate) || 0;
        //     const vraRate = parseFloat(editor?.vrarate) || 0;
        //     const vrRate = parseFloat(editor?.vrrate) || 0;

        //     // TOTAL RATE
        //     const totalRate =
        //       standardQty * standardRate +
        //       premierQty * premierRate +
        //       twilightQty * twilightRate +
        //       dtdQty * dtdRate +
        //       vraQty * vraRate +
        //       vrQty * vrRate;

        //     // INR PRICE
        //     const totalPrice = totalRate * (parseFloat(exchangeRate) || 83);

        //     // TAX
        //     const taxPercent = parseFloat(editor?.tax) || 0;

        //     const finalTotal = totalPrice + (totalPrice * taxPercent) / 100;

        //     flatRows.push({
        //       id: editor.id,
        //       invoiceId: editor.invoiceId,

        //       date: editor.date ? String(editor.date).split("T")[0] : "",

        //       editor_id: editor.editor_id || "",
        //       editor_name: editor.editor_name || "",

        //       projectName:
        //         editor.projectName || clientGroup.client_address || "",

        //       standard: editor.standard != null ? String(editor.standard) : "",

        //       premier: editor.premier != null ? String(editor.premier) : "",

        //       twilight: editor.twilight != null ? String(editor.twilight) : "",

        //       day_to_dusk:
        //         editor.day_to_dusk != null ? String(editor.day_to_dusk) : "",

        //       vra: editor.vra != null ? String(editor.vra) : "",

        //       vr: editor.vr != null ? String(editor.vr) : "",

        //       col7: editor.col7 != null ? String(editor.col7) : "",

        //       col8: editor.col8 != null ? String(editor.col8) : "",

        //       col9: editor.col9 != null ? String(editor.col9) : "",

        //       col10: editor.col10 != null ? String(editor.col10) : "",

        //       col11: editor.col11 != null ? String(editor.col11) : "",

        //       col12: editor.col12 != null ? String(editor.col12) : "",

        //       standardrate: standardRate,
        //       premierrate: premierRate,
        //       twilightrate: twilightRate,
        //       dtdrate: dtdRate,
        //       vrarate: vraRate,
        //       vrrate: vrRate,

        //       rate: totalRate.toFixed(2),
        //       price: totalPrice.toFixed(2),
        //       tax: taxPercent.toString(),
        //       totalAmount: finalTotal.toFixed(2),

        //       amount: "",
        //       quantity: 1,
        //       type: "",
        //       task_id: null,
        //       _isNew: false,
        //     });
        //   });
        // });

        rowRes.data.forEach((clientGroup) => {
          clientGroup.editors.forEach((editor) => {
            const standardQty = parseFloat(editor?.standard) || 0;
            const premierQty = parseFloat(editor?.premier) || 0;
            const twilightQty = parseFloat(editor?.twilight) || 0;
            const dtdQty = parseFloat(editor?.day_to_dusk) || 0;
            const vraQty = parseFloat(editor?.vra) || 0;
            const vrQty = parseFloat(editor?.vr) || 0;

            const standardRate = parseFloat(editor?.standardrate) || 0;
            const premierRate = parseFloat(editor?.premierrate) || 0;
            const twilightRate = parseFloat(editor?.twilightrate) || 0;
            const dtdRate = parseFloat(editor?.dtdrate) || 0;
            const vraRate = parseFloat(editor?.vrarate) || 0;
            const vrRate = parseFloat(editor?.vrrate) || 0;

            // TOTAL $
            const totalRate =
              standardQty * standardRate +
              premierQty * premierRate +
              twilightQty * twilightRate +
              dtdQty * dtdRate +
              vraQty * vraRate +
              vrQty * vrRate;

            // API VALUE USE PANNU
            const totalPrice = parseFloat(editor?.price) || 0;

            const taxPercent = parseFloat(editor?.tax) || 0;

            const finalTotal = totalPrice + (totalPrice * taxPercent) / 100;

            flatRows.push({
              id: editor.id,
              invoiceId: editor.invoiceId,

              date: editor.date ? String(editor.date).split("T")[0] : "",

              editor_id: editor.editor_id || "",
              editor_name: editor.editor_name || "",

              projectName:
                editor.projectName || clientGroup.client_address || "",

              standard: editor.standard != null ? String(editor.standard) : "",

              premier: editor.premier != null ? String(editor.premier) : "",

              twilight: editor.twilight != null ? String(editor.twilight) : "",

              day_to_dusk:
                editor.day_to_dusk != null ? String(editor.day_to_dusk) : "",

              vra: editor.vra != null ? String(editor.vra) : "",

              vr: editor.vr != null ? String(editor.vr) : "",

              col7: editor.col7 != null ? String(editor.col7) : "",

              col8: editor.col8 != null ? String(editor.col8) : "",

              col9: editor.col9 != null ? String(editor.col9) : "",

              col10: editor.col10 != null ? String(editor.col10) : "",

              col11: editor.col11 != null ? String(editor.col11) : "",

              col12: editor.col12 != null ? String(editor.col12) : "",

              standardrate: standardRate,
              premierrate: premierRate,
              twilightrate: twilightRate,
              dtdrate: dtdRate,
              vrarate: vraRate,
              vrrate: vrRate,

              // IMPORTANT
              rate: totalRate.toFixed(2),

              // API PRICE
              price: totalPrice.toFixed(2),

              tax: taxPercent.toString(),

              totalAmount: finalTotal.toFixed(2),

              amount: "",
              quantity: 1,
              type: "",
              task_id: null,
              _isNew: false,
            });
          });
        });

        setTableData(flatRows);

        // 3. Auto-detect visible columns from non-zero data
        const visibleCols = columnOrder.filter((col) =>
          flatRows.some((item) => {
            const v = item[col];
            return v && v.toString().trim() !== "" && parseFloat(v || 0) !== 0;
          }),
        );
        setVisibleColumns(visibleCols);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [invoice_id]);

  const [ClientDetails, setClientDetails] = useState([]);
  const clientdetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/clientdetails");
      if (response) setClientDetails(response.data);
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  useEffect(() => {
    clientdetails();
    categorytype();

    const fetchExchangeRate = async () => {
      const today = new Date().toISOString().split("T")[0];
      try {
        let response = await fetch(
          `https://api.frankfurter.dev/v1/${today}?base=USD&symbols=INR`,
        );
        if (!response.ok) {
          response = await fetch(
            "https://api.frankfurter.dev/v1/latest?base=USD&symbols=INR",
          );
        }
        const data = await response.json();
        setExchangeRate(data?.rates?.INR || 83);
      } catch (error) {
        setExchangeRate(83);
      }
    };
    fetchExchangeRate();
  }, []);

  const [currentDate] = useState(getFormattedDate());
  const [tableData, setTableData] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [netTotal, setNetTotal] = useState(0);
  const [clientRowCreated, setClientRowCreated] = useState(false);

  function filter() {
    const client = ClientDetails.find((data) => data.id === selectedClient);
    if (client) {
      setclientName(client.clientName);
      setclientaddress(client.address);
      setclientcountry(client.countrycode);
      setclientmobile(client.mobile);
    }
  }

  useEffect(() => {
    if (ClientDetails.length > 0 && selectedClient) filter();
  }, [ClientDetails, selectedClient]);

  // ── Add empty row manually ────────────────────────────────────────────────
  const handlerowadd = (e) => {
    e.preventDefault();
    setTableData((prev) => [
      ...prev,
      {
        id: Date.now(),
        date: getFormattedDate(),
        projectName: "",
        editor_id: "",
        editor_name: "",
        standard: "",
        premier: "",
        twilight: "",
        day_to_dusk: "",
        vra: "",
        vr: "",
        standardrate: "",
        premierrate: "",
        twilightrate: "",
        dtdrate: "",
        vrarate: "",
        vrrate: "",
        col7: "",
        col8: "",
        col9: "",
        col10: "",
        col11: "",
        col12: "",
        type: "",
        quantity: 1,
        price: 0,
        tax: "",
        amount: "",
        rate: "",
        task_id: null,
        _isNew: true,
      },
    ]);
    setClientRowCreated(true);
  };

  // const handleUserInputChange = (index, property, value) => {
  //   setTableData((prev) => {
  //     const updated = [...prev];
  //     updated[index] = { ...updated[index], [property]: value };
  //     if (property === "rate") {
  //       const rate = parseFloat(value) || 0;
  //       updated[index].price = (
  //         rate * (parseFloat(exchangeRate) || 83)
  //       ).toFixed(2);
  //     }
  //     return updated;
  //   });
  // };

  // ── Totals — price is already in INR (rate × exchangeRate), no second multiply ──
  // useEffect(() => {
  //   let sub = 0,
  //     tx = 0;
  //   tableData.forEach((item) => {
  //     const qty = parseFloat(item.quantity) || 1;
  //     const price = parseFloat(item.price) || 0;
  //     const taxRate = parseFloat(item.tax) || 0;
  //     const line = qty * price;
  //     sub += line;
  //     tx += (line * taxRate) / 100;
  //   });
  //   setSubtotal(sub);
  //   setTax(tx);
  //   setNetTotal(sub + tx);
  // }, [tableData]);

  const handleUserInputChange = (index, property, value) => {
    setTableData((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [property]: value,
      };

      const row = updated[index];

      const standardQty = parseFloat(row.standard) || 0;

      const premierQty = parseFloat(row.premier) || 0;

      const twilightQty = parseFloat(row.twilight) || 0;

      const dtdQty = parseFloat(row.day_to_dusk) || 0;

      const vraQty = parseFloat(row.vra) || 0;

      const vrQty = parseFloat(row.vr) || 0;

      const standardRate = parseFloat(row.standardrate) || 0;

      const premierRate = parseFloat(row.premierrate) || 0;

      const twilightRate = parseFloat(row.twilightrate) || 0;

      const dtdRate = parseFloat(row.dtdrate) || 0;

      const vraRate = parseFloat(row.vrarate) || 0;

      const vrRate = parseFloat(row.vrrate) || 0;

      // TOTAL RATE
      const totalRate =
        standardQty * standardRate +
        premierQty * premierRate +
        twilightQty * twilightRate +
        dtdQty * dtdRate +
        vraQty * vraRate +
        vrQty * vrRate;

      row.rate = totalRate.toFixed(2);

      // INR PRICE
      row.price = (totalRate * (parseFloat(exchangeRate) || 83)).toFixed(2);

      // TAX
      const taxPercent = parseFloat(row.tax) || 0;

      row.totalAmount = (
        parseFloat(row.price) +
        (parseFloat(row.price) * taxPercent) / 100
      ).toFixed(2);

      return updated;
    });
  };

  useEffect(() => {
    let sub = 0;
    let tx = 0;

    const isIndia = getclientcountry === "91";

    tableData.forEach((item) => {
      const qty = parseFloat(item.quantity) || 1;
      const taxRate = parseFloat(item.tax) || 0;

      if (isIndia) {
        // Existing logic (₹ price)
        const price = parseFloat(item.price) || 0;
        const line = qty * price;
        sub += line;
        tx += (line * taxRate) / 100;
      } else {
        // NEW logic (rate based)
        const rate = parseFloat(item.rate) || 0;
        const line = qty * rate;
        sub += line;
        tx += (line * taxRate) / 100;
      }
    });

    setSubtotal(sub);
    setTax(tx);
    setNetTotal(sub + tx);
  }, [tableData, getclientcountry]);

  const [deleteids, setDeleteIds] = useState([]);
  const tablerowdelete = (id) => {
    setTableData((prev) => prev.filter((item) => item.id !== id));
    if (id && typeof id === "number" && id < 1_000_000_000) {
      setDeleteIds((prev) => [...prev, id]);
    }
  };

  const handleClearAll = () => {
    setTableData([]);
    setClientRowCreated(false);
    setFromDate("");
    setToDate("");
    setTaskData([]);
  };

  const handleback = () => navigate("/invoice");

  const [getCategoryType, setCategoryType] = useState([]);
  const categorytype = async () => {
    try {
      const response = await axios.get(apiUrl + "/category");
      setCategoryType(response.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  function getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    return `${year}-${month}-${day}`;
  }

  // ── Generate: APPEND new tasks; existing rows keep all their data ─────────
  const handleGenerate = async () => {
    if (!fromDate || !toDate) {
      toast.error("Please select both From Date and To Date", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }
    if (!selectedClient) {
      toast.error("Client not found. Please reload.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }
    if (new Date(fromDate) > new Date(toDate)) {
      toast.error("From Date cannot be after To Date", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }

    setIsGenerating(true);
    try {
      const response = await axios.get(`${apiUrl}/taskmanagement`);
      const allTasks = response.data;

      const selectedClientData = ClientDetails.find(
        (c) => c.id === parseInt(selectedClient, 10),
      );
      const selectedClientName = selectedClientData?.clientName
        ?.toLowerCase()
        .trim();

      const from = new Date(fromDate);
      from.setHours(0, 0, 0, 0);
      const to = new Date(toDate);
      to.setHours(23, 59, 59, 999);

      const filtered = allTasks.filter((task) => {
        const cd = task.client_details?.find(
          (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
        );
        if (!cd) return false;
        const clientDate = new Date(cd.date); // uses "2026-04-24" from client_details
        return clientDate >= from && clientDate <= to;
      });

      if (filtered.length === 0) {
        toast.info("No tasks found for the selected client and date range.", {
          position: "top-right",
          autoClose: 3000,
        });
        setIsGenerating(false);
        return;
      }

      setTaskData(filtered);

      // Detect columns that have data in the new tasks
      const columnsWithData = new Set();
      filtered.forEach((task) => {
        const cd = task.client_details.find(
          (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
        );
        if (cd) {
          Object.keys(TASK_COLUMN_MAP).forEach((apiKey) => {
            const val = cd[apiKey];
            if (val && val !== 0 && val !== "0" && val !== "") {
              columnsWithData.add(TASK_COLUMN_MAP[apiKey]);
            }
          });
        }
      });

      const autoColumns = columnOrder.filter((col) => columnsWithData.has(col));
      setVisibleColumns((prev) => [...new Set([...prev, ...autoColumns])]);

      setColumnNames((prev) => {
        const updated = { ...prev };
        Object.keys(TASK_COLUMN_MAP).forEach((apiKey) => {
          const colKey = TASK_COLUMN_MAP[apiKey];
          if (columnsWithData.has(colKey)) {
            updated[colKey] = TASK_COLUMN_LABELS[apiKey];
          }
        });
        return updated;
      });

      const safeVal = (v) => (v && v !== 0 && v !== "0" ? String(v) : "");

      setTableData((prev) => {
        const existingTaskIds = new Set(
          prev.map((r) => r.task_id).filter(Boolean),
        );
        const existingKeys = new Set(
          prev.map((r) => {
            const d = String(r.date).split("T")[0];
            const p = r.projectName || "";
            const ei = r.editor_id || "";
            const en = r.editor_name || "";
            return `${d}__${p}__${ei}__${en}`;
          }),
        );

        const newRows = filtered
          .filter((task) => {
            const cd = task.client_details.find(
              (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
            );
            const dateStr = task.date ? String(task.date).split("T")[0] : "";
            const address = cd?.client_address || "";
            const editorId = task.editor_id || "";
            const editorName = task.editor_name || "";
            const key = `${dateStr}__${address}__${editorId}__${editorName}`;
            return !existingTaskIds.has(task.id) && !existingKeys.has(key);
          })
          .map((task) => {
            const cd = task.client_details.find(
              (c) => c.client_name?.toLowerCase().trim() === selectedClientName,
            );
            return {
              id: Date.now() + Math.random(),
              task_id: task.id,
              date: task.date
                ? String(task.date).split("T")[0]
                : getFormattedDate(),
              projectName: cd?.client_address || "",
              editor_id: task.editor_id || "",
              editor_name: task.editor_name || "",
              standard: safeVal(cd?.standard),
              premier: safeVal(cd?.premier),
              twilight: safeVal(cd?.twilight),
              day_to_dusk: safeVal(cd?.dtd),
              vra: safeVal(cd?.vra),
              vr: safeVal(cd?.vr),
              col7: "",
              col8: "",
              col9: "",
              col10: "",
              col11: "",
              col12: "",

              standardrate: cd?.standardrate || "",
              premierrate: cd?.premierrate || "",
              twilightrate: cd?.twilightrate || "",
              dtdrate: cd?.dtdrate || "",
              vrarate: cd?.vrarate || "",
              vrrate: cd?.vrrate || "",

              type: "",
              quantity: 1,
              price: 0,
              tax: "",
              amount: "",
              rate: "",
              _isNew: true,
            };
          });

        if (newRows.length === 0) {
          toast.info(
            "All tasks in this range are already loaded in the table.",
            {
              position: "top-right",
              autoClose: 3000,
            },
          );
          return prev;
        }

        toast.success(`${newRows.length} new row(s) added.`, {
          position: "top-right",
          autoClose: 2000,
        });

        return [...prev, ...newRows];
      });
    } catch (err) {
      console.error("Error fetching task data:", err);
      toast.error("Failed to fetch task data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } finally {
      setIsGenerating(false);
    }
  };

  const validateForm = () => {
    const empty = [];
    if (!selectedClient) empty.push("Client Name");
    if (!getData.date) empty.push("Date");
    if (!getData.dueDate) empty.push("Due Date");

    if (empty.length > 0) {
      toast(`Please fill: ${empty.join(", ")}`);
      return false;
    }
    return true;
  };

  const [isDataSubmitted, setIsDataSubmitted] = useState(false);
  const [getData, setData] = useState({
    invoiceId: "",
    clientName: "",
    date: "",
    dueDate: "",
    notes: "",
    totalTax: "",
    paymentStatus: "Unpaid",
    totalAmount: "",
    paymentDate: "",
  });

  const toaster = (cb) =>
    toast.success("Updated successfully!", { autoClose: 1000, onClose: cb });

  const submitdata = async () => {
    if (isDataSubmitted || !validateForm()) return;
    setIsDataSubmitted(true);

    try {
      // 1. Update invoice header
      const mainUpdate = {
        invoiceId: invoiceNo,
        clientName: selectedClient,
        date: getData.date,
        dueDate: getData.dueDate,
        totalAmount: netTotal.toFixed(2),
        notes: getData.notes,
        totalTax: tax.toFixed(2),
        paymentStatus: "Unpaid",
        paymentDate: "",
      };

      await axios.put(`${apiUrl}/invoicedetailsupdate/${invoicedetailsId}`, {
        ...getData,
        ...mainUpdate,
      });

      // 2. Delete removed rows
      for (const id of deleteids) {
        await axios.delete(`${apiUrl}/invoicelist/${id}`);
      }
      setDeleteIds([]);

      // 3. Build row payload
      const listData = tableData.map((data) => {
        const qty = parseFloat(data.quantity) || 1;
        const price = parseFloat(data.price) || 0;
        const taxRate = parseFloat(data.tax) || 0;
        const totalAmt = (qty * price * (1 + taxRate / 100)).toFixed(2);

        const isNewRow = !data.id || data.id > 100_000_000_000;

        const rowData = {
          invoiceId: invoiceNo,
          date: data.date || getFormattedDate(),
          clientName: selectedClient,
          projectName: data.projectName || "",
          editor_id: data.editor_id || "",
          editor_name: data.editor_name || "",
          standard: data.standard || "",
          premier: data.premier || "",
          twilight: data.twilight || "",
          day_to_dusk: data.day_to_dusk || "",
          vra: data.vra || "",
          vr: data.vr || "",
          standardrate: data.standardrate || 0,
          premierrate: data.premierrate || 0,
          twilightrate: data.twilightrate || 0,
          dtdrate: data.dtdrate || 0,
          vrarate: data.vrarate || 0,
          vrrate: data.vrrate || 0,
          col7: data.col7 || "",
          col8: data.col8 || "",
          col9: data.col9 || "",
          col10: data.col10 || "",
          col11: data.col11 || "",
          col12: data.col12 || "",
          type: data.type || "",
          quantity: qty,
          price: price.toString(),
          tax: taxRate.toString(),
          amount: data.amount || "",
          rate: data.rate || "",
          totalAmount: totalAmt,
        };

        if (!isNewRow) rowData.id = data.id;

        return rowData;
      });

      await axios.post(apiUrl + "/invoicelistupdate", listData);

      // Mark all rows as saved after successful submit
      setTableData((prev) => prev.map((row) => ({ ...row, _isNew: false })));

      toaster(() => navigate("/invoice"));
    } catch (err) {
      console.error(err);
      setIsDataSubmitted(false);

      if (err.response && err.response.data) {
        const message = err.response.data.message || "";

        if (message.includes("already exists")) {
          toast.error("Invoice ID already exists. Please use a different one.");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("Server error. Please try again.");
      }
    }
  };

  const handlenavigate = async () => {
    if (validateForm()) {
      try {
        await submitdata();
        setTimeout(() => navigate(`/invoice/invoiceprint/${invoice_id}`), 1000);
      } catch (error) {
        console.error("Error submitting data and navigating:", error);
      }
    }
  };

  const hasNewRows = tableData.some((r) => r._isNew);

  // Dynamic column count
  const hasEditorColumn = tableData.some((r) => r.editor_id || r.editor_name);

  let totalColumnsBeforeRate = 4 + visibleColumns.length;

  if (!hasEditorColumn) {
    totalColumnsBeforeRate -= 1;
  }

  // Totals
  const totalRate = tableData.reduce(
    (sum, item) => sum + (parseFloat(item.rate) || 0),
    0,
  );

  const totalPrice = tableData.reduce(
    (sum, item) => sum + (parseFloat(item.price) || 0),
    0,
  );

  const RATE_COLUMN_MAP = {
    standard: "standardrate",
    premier: "premierrate",
    twilight: "twilightrate",
    day_to_dusk: "dtdrate",
    vra: "vrarate",
    vr: "vrrate",
  };

  // clientrate value
  const getClientRateValue = (columnKey) => {
    if (!selectedClient) return "";

    // selected client details
    const selectedClientData = ClientDetails.find(
      (c) => c.id === parseInt(selectedClient, 10),
    );

    if (!selectedClientData) return "";

    // column key -> type name mapping
    const typeNameMap = {
      standard: "Standard",
      premier: "Premier",
      twilight: "Twilight",
      day_to_dusk: "Day To Dusk",
      vra: "Vra",
      vr: "Vr",
    };

    const typeName = typeNameMap[columnKey];

    if (!typeName) return "";

    // find type
    const typeData = clientRate.find(
      (item) =>
        item.type_name?.toLowerCase().trim() === typeName.toLowerCase().trim(),
    );

    if (!typeData) return "";

    // find same client_id inside client_data
    const clientData = typeData.client_data.find(
      (c) => c.client_id === selectedClientData.client_id,
    );

    return clientData?.value || "";
  };

  return (
    <>
      <ToastContainer />

      {/* Column Name Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditMode ? "Edit Column Name" : "Name Your Column"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCancel}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Column Name:</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalColumnName}
                  onChange={(e) => setModalColumnName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") handleModalSave();
                  }}
                  placeholder="Enter column name"
                  autoFocus
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <h3 className="text-center">Edit Invoice</h3>
      <hr /> */}
      <div className="mx-1">
        {/* Row 1 – Invoice No & Date */}
        <div className="invoicebackground1">
          <form className="row align-items-center">
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Invoice No.</label>
              <input
                className="form-control"
                value={invoiceNo}
                type="text"
                onChange={(e) => setInvoiceNo(e.target.value)}
              />
            </div>
            <div className="col-lg-6 col-md-4">
              <h3 className="text-center">Edit Invoice</h3>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Date :</label>
              <input
                className="form-control"
                type="date"
                value={getData.date || ""}
                onChange={(e) => setData({ ...getData, date: e.target.value })}
                required
              />
            </div>
          </form>
        </div>

        {/* Row 2 – Client | From Date | To Date | Buttons | Due Date */}
        <div className="invoicebackground1">
          <div className="row align-items-end g-2">
            {/* Client Name (read-only in edit mode) */}
            <div className="col-lg-2 col-md-4 col-sm-12">
              <label className="form-label fw-semibold">Client Name :</label>
              <div className="position-relative">
                <select
                  className="form-control custom-select"
                  value={selectedClient}
                  disabled
                >
                  <option value="">{getclientName}</option>
                </select>
              </div>
            </div>

            {/* From Date */}
            <div className="col-lg-2 col-md-4 col-sm-12">
              <label className="form-label fw-semibold">From Date :</label>
              <input
                className="form-control"
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="col-lg-2 col-md-4 col-sm-12">
              <label className="form-label fw-semibold">To Date :</label>
              <input
                className="form-control"
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            {/* Generate / Add Row / Add Column */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap gap-2 pb-1">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleGenerate}
                  disabled={isGenerating}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {isGenerating ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Generating...
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-bolt me-1"></i>Generate
                    </>
                  )}
                </button>

                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={handlerowadd}
                  style={{ whiteSpace: "nowrap" }}
                >
                  <i className="fa-solid fa-plus me-1"></i>Add Row
                </button>

                {visibleColumns.length < 12 && (
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={handleAddColumn}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <i className="fa-solid fa-plus me-1"></i>Add Column
                  </button>
                )}
              </div>
            </div>

            {/* Due Date */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <label className="form-label fw-semibold">Due Date :</label>
              <input
                className="form-control"
                value={getData.dueDate || ""}
                type="date"
                onChange={(e) =>
                  setData({ ...getData, dueDate: e.target.value })
                }
                required
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="invoicebackground1">
          {/* Legend — only shown when there are new/unsaved rows */}
          {hasNewRows && (
            <div
              className="mb-2 d-flex align-items-center gap-3"
              style={{ fontSize: "12px" }}
            >
              <span
                style={{
                  backgroundColor: "#fff8e1",
                  border: "1px solid #ffe082",
                  padding: "3px 12px",
                  borderRadius: "4px",
                  fontWeight: 500,
                }}
              >
                🟡 New — unsaved (from task filter)
              </span>
              <span
                style={{
                  backgroundColor: "#f0fff4",
                  border: "1px solid #b2dfdb",
                  padding: "3px 12px",
                  borderRadius: "4px",
                  fontWeight: 500,
                }}
              >
                ✅ Saved
              </span>
            </div>
          )}

          <div style={{ width: "100%", overflowX: "auto" }}>
            <table
              className="table table-bordered"
              style={{ minWidth: "1400px", tableLayout: "fixed" }}
            >
              <thead className="font-size">
                <tr>
                  <th style={{ width: "30px" }}>S.No</th>
                  <th style={{ width: "120px" }}>Date</th>
                  <th style={{ width: "120px" }}>Address</th>

                  {tableData.some((r) => r.editor_id || r.editor_name) && (
                    <>
                      {/* <th style={{ width: "100px" }}>Editor ID</th>
                      <th style={{ width: "120px" }}>Editor Name</th> */}

                      <th style={{ width: "120px" }}>Editor Id / Name</th>
                    </>
                  )}

                  {visibleColumns.map((colKey) => (
                    <th key={colKey} style={{ width: "90px" }}>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: "5px", overflow: "hidden" }}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title={columnNames[colKey]}
                        >
                          <div className="d-flex flex-column">
                            <span>{columnNames[colKey]}</span>

                            {getClientRateValue(colKey) && (
                              <small
                                style={{
                                  color: "#198754",
                                  fontSize: "13px",
                                  fontWeight: "600",
                                }}
                              >
                                ($ {getClientRateValue(colKey)})
                              </small>
                            )}
                          </div>
                        </span>

                        <i
                          className="fa-solid fa-edit"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title="Edit column name"
                        ></i>
                        <i
                          className="fa-solid fa-trash text-danger"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            flexShrink: 0,
                          }}
                          onClick={() => handleRemoveColumn(colKey)}
                          title="Remove column"
                        ></i>
                      </div>
                    </th>
                  ))}

                  <th style={{ width: "75px" }}>$ Rate</th>
                  <th style={{ width: "70px" }}>Tax %</th>
                  <th style={{ width: "70px" }}>₹ Price</th>
                  <th style={{ width: "60px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr
                    key={item.id}
                    style={{
                      backgroundColor: item._isNew ? "#fff8e1" : "#f0fff4",
                      transition: "background-color 0.2s",
                    }}
                  >
                    <th scope="row">{index + 1}</th>
                    <td>
                      <input
                        style={{
                          width: "100%",
                          backgroundColor: "transparent",
                        }}
                        className="form-control pe-0"
                        type="date"
                        value={item.date || ""}
                        onChange={(e) =>
                          handleUserInputChange(index, "date", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        style={{
                          width: "100%",
                          backgroundColor: "transparent",
                        }}
                        className="form-control"
                        type="text"
                        value={item.projectName || ""}
                        onChange={(e) =>
                          handleUserInputChange(
                            index,
                            "projectName",
                            e.target.value,
                          )
                        }
                      />
                    </td>

                    {/* {tableData.some((r) => r.editor_id || r.editor_name) && (
                      <>
                        <td>
                          <input
                            className="form-control"
                            style={{ backgroundColor: "transparent" }}
                            type="text"
                            value={item.editor_id || ""}
                            onChange={(e) =>
                              handleUserInputChange(
                                index,
                                "editor_id",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            style={{ backgroundColor: "transparent" }}
                            type="text"
                            value={item.editor_name || ""}
                            onChange={(e) =>
                              handleUserInputChange(
                                index,
                                "editor_name",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </>
                    )} */}

                    {tableData.some((r) => r.editor_id || r.editor_name) && (
                      <td>
                        <input
                          className="form-control"
                          style={{ backgroundColor: "transparent" }}
                          type="text"
                          value={`${item.editor_id || ""}${
                            item.editor_id && item.editor_name ? " - " : ""
                          }${item.editor_name || ""}`}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Split "ID - Name"
                            const parts = value.split(" - ");
                            handleUserInputChange(
                              index,
                              "editor_id",
                              parts[0] || "",
                            );
                            handleUserInputChange(
                              index,
                              "editor_name",
                              parts[1] || "",
                            );
                          }}
                          placeholder="Editor ID - Name"
                        />
                      </td>
                    )}

                    {/* {visibleColumns.map((colKey) => (
                      <td key={colKey}>
                        <input
                          className="form-control"
                          style={{ backgroundColor: "transparent" }}
                          type="text"
                          value={item[colKey] || ""}
                          onChange={(e) =>
                            handleUserInputChange(index, colKey, e.target.value)
                          }
                        />
                      </td>
                    ))} */}

                    {visibleColumns.map((colKey) => (
                      <td key={colKey}>
                        <div className="d-flex gap-1">
                          {/* LEFT INPUT = QTY */}
                          <input
                            className="form-control form-control-sm"
                            style={{
                              backgroundColor: "transparent",
                            }}
                            type="text"
                            value={item[colKey] || ""}
                            onChange={(e) =>
                              handleUserInputChange(
                                index,
                                colKey,
                                e.target.value,
                              )
                            }
                            placeholder="Qty"
                          />

                          {/* RIGHT INPUT = RATE */}
                          <input
                            className="form-control form-control-sm"
                            style={{
                              backgroundColor: "transparent",
                            }}
                            type="text"
                            // value={item[`${colKey}rate`] || ""}
                            value={item[RATE_COLUMN_MAP[colKey]] || ""}
                            onChange={(e) =>
                              // handleUserInputChange(
                              //   index,
                              //   `${colKey}rate`,
                              //   e.target.value,
                              // )

                              handleUserInputChange(
                                index,
                                RATE_COLUMN_MAP[colKey],
                                e.target.value,
                              )
                            }
                            placeholder="Rate"
                          />
                        </div>
                      </td>
                    ))}

                    <td>
                      <input
                        className="form-control ps-2"
                        style={{ backgroundColor: "transparent" }}
                        placeholder="rate"
                        value={item.rate || ""}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          handleUserInputChange(index, "rate", value);
                        }}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        style={{ backgroundColor: "transparent" }}
                        type="tel"
                        value={item.tax || ""}
                        placeholder="Tax"
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          handleUserInputChange(index, "tax", value);
                        }}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        style={{ backgroundColor: "transparent" }}
                        type="tel"
                        value={item.price || 0}
                        readOnly
                      />
                    </td>
                    <td>
                      <button
                        className="btn btn-danger px-1 py-1 d-flex align-items-center"
                        onClick={() => tablerowdelete(item.id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table -secondary">
                <tr>
                  {/* Dynamic span till RATE column */}
                  <td
                    colSpan={totalColumnsBeforeRate}
                    style={{ textAlign: "right" }}
                  >
                    <b>Total</b>
                  </td>

                  {/* $ Rate Total */}
                  <td>
                    <input
                      className="form-control fw-bold"
                      value={totalRate.toFixed(2)}
                      readOnly
                    />
                  </td>

                  {/* Tax column empty */}
                  <td></td>

                  {/* ₹ Price Total */}
                  <td colSpan={2}>
                    <input
                      className="form-control fw-bold"
                      value={totalPrice.toFixed(2)}
                      readOnly
                    />
                  </td>

                  {/* Action column empty */}
                  {/* <td></td> */}
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Notes + Totals */}
          <div className="row mt-4">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <label className="form-label">
                <b>Notes :</b>
                <br />
                <textarea
                  className="form-control notes-textarea"
                  value={getData.notes || ""}
                  onChange={(e) =>
                    setData({ ...getData, notes: e.target.value })
                  }
                  required
                />
              </label>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <form>
                <div className="row">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Sub Total ({getclientcountry === "91" ? "₹" : "$"})</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹ ${subtotal.toFixed(2)}`
                          : `$ ${subtotal.toFixed(2)}`
                      }
                      type="text"
                      placeholder="Sub Total"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>
                        Paypal Tax ({getclientcountry === "91" ? "₹" : "$"})
                      </b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹ ${tax.toFixed(2)}`
                          : `$ ${tax.toFixed(2)}`
                      }
                      type="text"
                      placeholder="Tax"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Net Total ({getclientcountry === "91" ? "₹" : "$"})</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    {/* FIX: use netTotal directly — price is already rate × exchangeRate */}
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹ ${Math.round(netTotal).toFixed(2)}`
                          : `$ ${Math.round(netTotal).toFixed(2)}`
                      }
                      type="text"
                      placeholder="Net Total"
                      readOnly
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Action buttons */}
          <div className="row">
            <div className="col-lg-5"></div>
            <div className="col-lg-7">
              <div
                style={{ marginLeft: "75px" }}
                className="d-flex justify-content-end gap-5 mt-3 buttonstyle"
              >
                <button
                  type="button"
                  className="btn btn-danger invoice-button"
                  onClick={handleClearAll}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-info text-white invoice-button"
                  style={{ backgroundColor: "#007BFF" }}
                  onClick={handleback}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn btn-success invoice-button"
                  onClick={submitdata}
                >
                  Update
                </button>
                {/* <button
                  type="button"
                  className="btn btn-secondary invoice-button"
                  onClick={handlenavigate}
                >
                  Print
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InvoiceUpdate;
